import React, { useEffect, useState } from "react";
import Sidebar from "../../components/common/Sidebar";
import Header from "../../components/common/Header";
import Doctor from "./Doctor";
import Nurse from "./Nurse";
import Physico from "./Physico";
import Scientist from "./Scientist";
import { useLocation, useNavigate } from "react-router-dom";
import { setCurrentPage } from "../../redux/slices/currentPageSlice";
import { useDispatch } from "react-redux";

const Professional = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const tabFromUrl = queryParams.get("tab") || "Doctor";
  const pageFromUrl = parseInt(queryParams.get("page") || "1", 10);

  const [activeTab, setActiveTab] = useState(tabFromUrl);

  useEffect(() => {
    setActiveTab(tabFromUrl);
    dispatch(setCurrentPage(pageFromUrl));
  }, [dispatch, pageFromUrl, tabFromUrl]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    dispatch(setCurrentPage(1));
    navigate(`/professional?page=1&tab=${tab}`);
  };
  return (
    <div class="admin-dashboard">
      <Sidebar />
      <div class="main-dashboard subadmin-dashboard">
        <Header title={"Professional"} />
        <div class="loaction-list-main">
          <div class="request-selection">
            <ul>
              <li
                className={activeTab === "Doctor" ? "request-active" : ""}
                onClick={() => handleTabClick("Doctor")}
              >
                Doctor
              </li>
              <li
                className={activeTab === "Nurse" ? "request-active" : ""}
                onClick={() => handleTabClick("Nurse")}
              >
                Nurse
              </li>
              <li
                className={
                  activeTab === "Physiotherapist" ? "request-active" : ""
                }
                onClick={() => handleTabClick("Physiotherapist")}
              >
                Physiotherapist
              </li>
              <li
                className={
                  activeTab === "Lab Scientist" ? "request-active" : ""
                }
                onClick={() => handleTabClick("Lab Scientist")}
              >
                Lab Scientist
              </li>
            </ul>
          </div>
          {activeTab === "Doctor" && <Doctor />}
          {activeTab === "Nurse" && <Nurse />}
          {activeTab === "Physiotherapist" && <Physico />}
          {activeTab === "Lab Scientist" && <Scientist />}
        </div>
      </div>
    </div>
  );
};

export default Professional;
